// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.selection-container, .not-found {
  background-color: #f7f0e4;
}

ul.panel-bullets {
  list-style: none;
}

ul.panel-bullets li::before {
  content: "\\2022";
  color: #D62311;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
  line-height: 2.0em;
}
.olr-align-bullets {
  padding-inline-start:24px;
}

.olr-account-type-margin {
  margin-top: 0;
  margin-left: 16px;
  margin-right: 16px;
  margin-bottom: 16px;
}
.olr-claim-type-margin {
  margin: 16px;
}
.olr-policy-container-margins {
  margin-bottom: 16px;
}
.olr-center-text {
  text-align:center;
}
.olr-right-align-text {
  text-align:right;
}
.olr-merna03-red {
  color: #D62311;
}
.olr-charcoal02 {
  color: #403C3C
}
.olr-footer-note-margins {
  margin-bottom:24px;
}
a {
  cursor: pointer;
}
.olr-baas-margin {
  margin-bottom: 16px;
}
.olr-button-right-padding {
  padding-left: 8px;
  padding-right: 15px;
}
.olr-button-left-padding {
  padding-left: 15px;
  padding-right: 8px;
}
.olr-new-entry-header {
  color: #403C3C;
  font-weight: 600;
  margin-top: 28px;
}
.olr-hr-claimant-margins {
  margin-top:28px;
  margin-bottom:32px;
}
.olr-entry-bottom-margin {
  margin-bottom: 60px;
}



@media screen and (min-width: 768px) {
  h1 {
    font-size: 28px;
  }
}

@media screen and (max-width: 576px) {
  .olr-new-entry-header {
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 32px;
  }
  .olr-policy-msg-spacing {
    margin-bottom: 32px;
  }
  .olr-claim-type-card {
    font-size: 20px;
    line-height: 26px;
  }
  .olr-claimant-header {
    font-size: 20px;
    line-height:20px;
  }
}

@media (min-width: 768px) {
  .olr-new-entry-header {
    font-size: 39px;
    line-height: 39px;
    margin-bottom: 40px;
  }
  .olr-policy-msg-spacing {
    margin-bottom: 40px;
  }
  .olr-claim-type-card {
    font-size: 23px;
    line-height: 29px;
  }
  .olr-claimant-header {
    font-size: 23px;
    line-height:23px;
  }
}

@media (min-width: 992px) {
  .olr-inactive-policies-header {
    color: #403C3C;
    font-size: 25px;
    line-height: 25px;
    margin-bottom: 16px;
  }
  .olr-new-entry-header {
    font-size: 48px;
    line-height: 48px;
    margin-bottom: 40px;
  }
  .olr-policy-msg-spacing {
    margin-bottom: 40px;
  }
  .olr-claim-type-card {
    font-size: 25px;
    line-height: 30px;
  }
  .olr-claimant-header {
    font-size: 25px;
    line-height:25px;
  }
  #not_sfcustomer {
    line-height: 30px;
  }
}

.clickable {
  font-weight: bold;
  color:#D62311;
  font-size: 15px;
}

.unauthenticated-helpful-tips {
  margin-bottom: 5%;
  text-align: right;
}


.lr-sb-button-text-alignment {
  margin-left:25px;
  position: absolute;
  top: 35%;
}
.lr-sb-button-flex-item-grow {
  flex-grow:1;
  position: relative;
}
.lr-sb-vertical-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.lr-sb-button-body {
  text-align: left;
  padding: 16px;
  height: auto;
  margin-bottom: 16px;
}
.lr-sb-button-flex-container {
  display:flex;
  flex-direction: row;
}

/* Images on Dropdown */
select { font-family: "FontAwesome","MecherleSans",Arial;}

/* Global Alert */
  .-oneX-global-alert-container {
    /*border: 4px solid #000000;*/
    border-radius: 4px;
    padding: 16px;
    box-shadow: 0 24px 32px rgba(0, 0, 0, 0.3);
   }

  .-oneX-global-alert-header {
    color: #faf7f7;
    font-family: "MecherleSans", Arial;
    font-size: 31px;
    font-weight: 600;
    line-height: 31px;
    margin: 0;
    outline: none;
    padding-top: 16px;
    text-align: center;
  }

  .-oneX-global-alert-body {
    font-family: "MecherleSans", Arial;
    font-size: 16px;
    color: #faf4f4;
    margin-top: 8px;
    text-align: center;
  }

  .-oneX-close-X-button {
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 18px;
    right: 16px;
  } 

   .-oneX-icon--close {
    font-size: 24px;
    color: #D62311;
  }

   .shouldIFileAlignment{
    text-align: right ! important;
  } 
  
  a[href="https://reportloss.claims.test.statefarm.com/start-claim"] {
    color: #D62311;
    font-weight: bold;
    text-decoration: none;
  }

  a[href="https://reportloss.claims.test.statefarm.com/start-claim"]:hover {
    text-decoration: underline;
  }`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/entry-point/entry-point.component.css"],"names":[],"mappings":";AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE;AACF;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;;;AAIA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB,SAAS,+CAA+C,CAAC;;AAEzD,iBAAiB;EACf;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,0CAA0C;GAC3C;;EAED;IACE,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;GAEC;IACC,eAAe;IACf,cAAc;EAChB;;GAEC;IACC,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B","sourcesContent":["\n.selection-container, .not-found {\n  background-color: #f7f0e4;\n}\n\nul.panel-bullets {\n  list-style: none;\n}\n\nul.panel-bullets li::before {\n  content: \"\\2022\";\n  color: #D62311;\n  font-weight: bold;\n  display: inline-block;\n  width: 1em;\n  margin-left: -1em;\n  line-height: 2.0em;\n}\n.olr-align-bullets {\n  padding-inline-start:24px;\n}\n\n.olr-account-type-margin {\n  margin-top: 0;\n  margin-left: 16px;\n  margin-right: 16px;\n  margin-bottom: 16px;\n}\n.olr-claim-type-margin {\n  margin: 16px;\n}\n.olr-policy-container-margins {\n  margin-bottom: 16px;\n}\n.olr-center-text {\n  text-align:center;\n}\n.olr-right-align-text {\n  text-align:right;\n}\n.olr-merna03-red {\n  color: #D62311;\n}\n.olr-charcoal02 {\n  color: #403C3C\n}\n.olr-footer-note-margins {\n  margin-bottom:24px;\n}\na {\n  cursor: pointer;\n}\n.olr-baas-margin {\n  margin-bottom: 16px;\n}\n.olr-button-right-padding {\n  padding-left: 8px;\n  padding-right: 15px;\n}\n.olr-button-left-padding {\n  padding-left: 15px;\n  padding-right: 8px;\n}\n.olr-new-entry-header {\n  color: #403C3C;\n  font-weight: 600;\n  margin-top: 28px;\n}\n.olr-hr-claimant-margins {\n  margin-top:28px;\n  margin-bottom:32px;\n}\n.olr-entry-bottom-margin {\n  margin-bottom: 60px;\n}\n\n\n\n@media screen and (min-width: 768px) {\n  h1 {\n    font-size: 28px;\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .olr-new-entry-header {\n    font-size: 28px;\n    line-height: 28px;\n    margin-bottom: 32px;\n  }\n  .olr-policy-msg-spacing {\n    margin-bottom: 32px;\n  }\n  .olr-claim-type-card {\n    font-size: 20px;\n    line-height: 26px;\n  }\n  .olr-claimant-header {\n    font-size: 20px;\n    line-height:20px;\n  }\n}\n\n@media (min-width: 768px) {\n  .olr-new-entry-header {\n    font-size: 39px;\n    line-height: 39px;\n    margin-bottom: 40px;\n  }\n  .olr-policy-msg-spacing {\n    margin-bottom: 40px;\n  }\n  .olr-claim-type-card {\n    font-size: 23px;\n    line-height: 29px;\n  }\n  .olr-claimant-header {\n    font-size: 23px;\n    line-height:23px;\n  }\n}\n\n@media (min-width: 992px) {\n  .olr-inactive-policies-header {\n    color: #403C3C;\n    font-size: 25px;\n    line-height: 25px;\n    margin-bottom: 16px;\n  }\n  .olr-new-entry-header {\n    font-size: 48px;\n    line-height: 48px;\n    margin-bottom: 40px;\n  }\n  .olr-policy-msg-spacing {\n    margin-bottom: 40px;\n  }\n  .olr-claim-type-card {\n    font-size: 25px;\n    line-height: 30px;\n  }\n  .olr-claimant-header {\n    font-size: 25px;\n    line-height:25px;\n  }\n  #not_sfcustomer {\n    line-height: 30px;\n  }\n}\n\n.clickable {\n  font-weight: bold;\n  color:#D62311;\n  font-size: 15px;\n}\n\n.unauthenticated-helpful-tips {\n  margin-bottom: 5%;\n  text-align: right;\n}\n\n\n.lr-sb-button-text-alignment {\n  margin-left:25px;\n  position: absolute;\n  top: 35%;\n}\n.lr-sb-button-flex-item-grow {\n  flex-grow:1;\n  position: relative;\n}\n.lr-sb-vertical-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.lr-sb-button-body {\n  text-align: left;\n  padding: 16px;\n  height: auto;\n  margin-bottom: 16px;\n}\n.lr-sb-button-flex-container {\n  display:flex;\n  flex-direction: row;\n}\n\n/* Images on Dropdown */\nselect { font-family: \"FontAwesome\",\"MecherleSans\",Arial;}\n\n/* Global Alert */\n  .-oneX-global-alert-container {\n    /*border: 4px solid #000000;*/\n    border-radius: 4px;\n    padding: 16px;\n    box-shadow: 0 24px 32px rgba(0, 0, 0, 0.3);\n   }\n\n  .-oneX-global-alert-header {\n    color: #faf7f7;\n    font-family: \"MecherleSans\", Arial;\n    font-size: 31px;\n    font-weight: 600;\n    line-height: 31px;\n    margin: 0;\n    outline: none;\n    padding-top: 16px;\n    text-align: center;\n  }\n\n  .-oneX-global-alert-body {\n    font-family: \"MecherleSans\", Arial;\n    font-size: 16px;\n    color: #faf4f4;\n    margin-top: 8px;\n    text-align: center;\n  }\n\n  .-oneX-close-X-button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    position: absolute;\n    top: 18px;\n    right: 16px;\n  } \n\n   .-oneX-icon--close {\n    font-size: 24px;\n    color: #D62311;\n  }\n\n   .shouldIFileAlignment{\n    text-align: right ! important;\n  } \n  \n  a[href=\"https://reportloss.claims.test.statefarm.com/start-claim\"] {\n    color: #D62311;\n    font-weight: bold;\n    text-decoration: none;\n  }\n\n  a[href=\"https://reportloss.claims.test.statefarm.com/start-claim\"]:hover {\n    text-decoration: underline;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
